import { styled } from '@raskrask-dk/rr-components'

const StyledAdminSettings = styled('div', {
    width: '100%',
    position: 'relative',
})

export default StyledAdminSettings
